import { api, ApiResponse } from './api'

/**
 * H3 del roadmap (Fase C #8): alertas de anomalías y de capping.
 */

export interface VolumeAlert {
  type: 'campaign' | 'sourcePage'
  name: string
  date: string
  dayType: 'weekday' | 'weekend'
  today: number
  historicalMean: number
  sampleSize: number
  percentDeviation: number
  direction: 'up' | 'down'
}

export interface UniqueRatioAlert {
  sourcePage: string
  previousDate: string
  latestDate: string
  previousUniquePct: number
  latestUniquePct: number
  deltaPercentagePoints: number
}

export interface CappingAlert {
  campaign: string
  capping: number
  leadsSoFar: number
  daysWithData: number
  dailyPace: number
  projectedDaysToReach: number | null
  alreadyReached: boolean
}

export interface AlertsData {
  volumeAlerts: VolumeAlert[]
  uniqueRatioAlerts: UniqueRatioAlert[]
  cappingAlerts: CappingAlert[]
  thresholds: {
    minSamplesForBaseline: number
    volumeDeviationThresholdPct: number
    uniqueRatioDeltaThresholdPp: number
  }
}

export const getAlerts = async (): Promise<ApiResponse<AlertsData>> => {
  const response = await api.get<ApiResponse<AlertsData>>('/dashboard/alerts')
  return response.data
}
